import { useCallback, useState } from "react";
import { useSaveDownloaded } from "../../../../../lib/hooks/useSaveDownloaded";
import ReportService from "../../../../../services/reportGeneration";

export const useExport = (form: any, closeModal: (value: boolean) => void) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { save } = useSaveDownloaded(
    "PayoffPayments.xlsx",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
    setIsLoading,
  );

  const onExportClicked = useCallback(async () => {
    try {
      setIsLoading(true);

      const values = await form.validateFields();

      const request: any = {
        dateFrom: values.dates[0].format(),
        dateTo: values.dates[1].format(),
      };

      const res: any = await ReportService.exportByName(
        "PayoffPayments",
        request,
      );

      save(res);
      closeModal(false);
    } catch {
      setIsLoading(false);
    }
  }, [form, save, closeModal]);

  return { onExportClicked, isLoading };
};
